export enum BigScreenDisplayMode {
    HORIZONTAL_SCROLL= 'HORIZONTAL_SCROLL',
    VERTICAL_SCROLL = 'VERTICAL_SCROLL',
    BOTH = 'BOTH',
}
